import { render } from "./megaphone.vue?vue&type=template&id=02ac6c68&lang=pug"
import script from "./megaphone.vue?vue&type=script&lang=js"
export * from "./megaphone.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__